import { useState } from "react";
import { setKey, api } from "./api";
import { KeyRound } from "lucide-react";

export default function KeyGate({ onUnlock }) {
  const [value, setValue] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!value.trim()) return;
    setBusy(true);
    setError("");
    setKey(value.trim());
    try {
      await api.listJobs();
      onUnlock();
    } catch (err) {
      setError(err.status === 401 ? "That key was not recognised." : err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 bg-slate-950">
      <form
        onSubmit={submit}
        data-testid="key-gate-form"
        className="w-full max-w-sm rounded-2xl bg-slate-900/70 ring-1 ring-slate-800 p-7 shadow-2xl"
      >
        <div className="flex items-center gap-3 mb-6">
          <span className="grid h-11 w-11 place-items-center rounded-xl bg-amber-500/15 ring-1 ring-amber-500/30">
            <KeyRound className="h-5 w-5 text-amber-300" />
          </span>
          <div>
            <p className="text-[11px] uppercase tracking-widest text-amber-400/80">Alias · JoRevGen</p>
            <h1 className="text-lg font-semibold text-slate-100">Operator sign-in</h1>
          </div>
        </div>
        <label className="block text-xs text-slate-400 mb-2">Operator key</label>
        <input
          type="password"
          value={value}
          autoFocus
          onChange={(e) => setValue(e.target.value)}
          data-testid="operator-key-input"
          className="w-full rounded-xl bg-slate-950 ring-1 ring-slate-700 focus:ring-amber-500 px-3.5 py-3 text-slate-100 outline-none transition"
          placeholder="Enter your key"
        />
        {error && <p data-testid="key-gate-error" className="mt-3 text-sm text-rose-400">{error}</p>}
        <button
          type="submit"
          disabled={busy}
          data-testid="key-gate-submit"
          className="mt-5 w-full rounded-xl bg-amber-500 py-3 font-semibold text-slate-950 hover:bg-amber-400 disabled:opacity-60 transition-colors"
        >
          {busy ? "Checking…" : "Continue"}
        </button>
      </form>
    </div>
  );
}
